import { render } from "./AttachmentExercise.vue?vue&type=template&id=4973d235&ts=true"
import script from "./AttachmentExercise.vue?vue&type=script&lang=ts"
export * from "./AttachmentExercise.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__